import React from "react";
import "./Pronounce.css";

export default function Pronounce(props) {
  function play() {
    var audio = new Audio(props.data.audio);
    audio.play();
  }

  return (
    <div className="Pronounce">
      <div className="row">
        <div className="col">
          <button className="btn btn-sm speakerButton mt-2 mx-0" onClick={play}>
            <span className="audioIcon">
              <img
                src="https://img.icons8.com/ios-glyphs/20/ffffff/speaker.png"
                alt=""
              />
            </span>
          </button>
        </div>
        <div className="col ms-0 ps-0">
          <h3 className="searchedWord p-0 m-0">{props.data.word}</h3>
        </div>
      </div>
      <div className="row ms-0">
        <div className="col mt-2">
          <h4 className="phoneticWord">/{props.data.phonetic}/</h4>
        </div>
      </div>
    </div>
  );
}
